<div class="poi-list">
  <div *ngFor="let poiHtml of poiListHtml" class="poi-item" [innerHTML]="poiHtml"></div>
</div>
